import { OfficeConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload: { clear, ...payload } = {}, type } = action;
  switch (type) {
    case OfficeConstant.SET_OFFICE:
      return { ...state, clear, detail: payload };
    case OfficeConstant.SET_OFFICES:
      return { ...state, clear, list: payload };
    default:
      return state;
  }
};
